import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as occupants from '../../occupants'
import type { TypeParams } from '../types'

/**
 * After a new employee is created, automatically adds them to the current
 * occupant selection so that they appear checked in the employee selector
 * without any further user interaction.
 */
export const autoSelectOnCreateForOccupants = store.effects.create(
  (
    _: ec.Collection<TypeParams>['feature'],
    collection: ec.Collection<TypeParams>,
    recordOccupantsEc: occupants.recordOccupants.Collection,
    clusterOccupantsEc: occupants.clusterOccupants.Collection,
  ) =>
    collection.plugins.dataOperationPlugin.feature.actions.create.success
      .observe()
      .pipe(
        rxjs.mergeMap(action =>
          rxjs
            .combineLatest([
              recordOccupantsEc.plugins.currentEntityPlugin.feature.selectors.isCreating()
                .asObservable,
              clusterOccupantsEc.plugins.currentEntityPlugin.feature.selectors.isCreating()
                .asObservable,
            ])
            .pipe(
              rxjs.take(1),
              rxjs.mergeMap(([isCreatingRecord, isCreatingCluster]) => {
                const employees = action.data.response ?? []

                if (!employees.length) {
                  return rxjs.EMPTY
                }

                const tasks: rxjs.Observable<any>[] = []

                if (isCreatingRecord) {
                  tasks.push(
                    rxjs.of(
                      collection.plugins.selectionPlugin.applied.actions.putInSelectionLookup
                        .from('autoSelectOnCreateForOccupants (effect)')
                        .create({
                          key: recordOccupantsEc.associations?.selectionTarget,
                          value: {
                            add: employees.map(e => collection.identify(e)),
                          },
                        }),
                    ),
                  )
                }

                if (isCreatingCluster) {
                  tasks.push(
                    rxjs.of(
                      collection.plugins.selectionPlugin.applied.actions.putInSelectionLookup
                        .from('autoSelectOnCreateForOccupants (effect)')
                        .create({
                          key: clusterOccupantsEc.associations?.selectionTarget,
                          value: {
                            add: employees.map(e => collection.identify(e)),
                          },
                        }),
                    ),
                  )
                }

                return rxjs.merge(...tasks)
              }),
            ),
        ),
      ),
)
